module.exports = __webpack_public_path__ + "static/media/accumulate.dd72b0e0.svg";